// extracted by mini-css-extract-plugin
export default {"root":"RangeSlider_root__qRb1L","activeHandle":"RangeSlider_activeHandle__asZpE"};